export var GUIDES_ROUTER = {
    MAIN: "/guides",
    GUIDES_FAVORITES: "/guides/favorites",
    SECOND: "/guides/second",
};
